// The terminal id comes from an untrusted URL query param (`?terminal=…`) that
// gets shared, deep-linked and QR-encoded, so it frequently arrives polluted
// with trailing junk:
//   "3&zarsrc=1303&utm_source=zalo&utm_medium=zalo&utm_campaign=zalo"  (Zalo share params)
//   "3%3C%2Fa"                                                         (leaked "</a" HTML)
//   "1%3C%2Fahttps%3A%2F%2Fdxb.pocketflights.com%2F%3Fterminal%3D1"    (a full URL glued on)
// In every case the real terminal is the leading number, so keep only that and
// drop anything after it. Returns a clean numeric string, or null when the value
// is missing / has no leading digits (so callers treat it as "no terminal").
export const parseTerminalId = (raw) => {
  if (raw == null) {
    return null;
  }
  // Trim surrounding whitespace, allow an optional "T"/"t" prefix (printed QRs
  // sometimes read as "T1"), then keep the leading number and drop the rest.
  const match = String(raw)
    .trim()
    .match(/^[Tt]?(\d+)/);
  return match ? match[1] : null;
};
